import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { ApplicantStatus } from "Globals/Models/ApplicantStatus";

export class ApplicantStatusStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private applicantStatus: ApplicantStatus[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.applicantStatus = initialState.applicantStatus;
    }

    @MobX.action
    public getApplicantStatusName(applicantStatusId: string | null): string {
        if (applicantStatusId == "0" || applicantStatusId == null || applicantStatusId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => applicantStatusId == value.id);
        return value ? value.name : "Unknown";
    }
    @MobX.action
    public getApplicantStatusColor(applicantStatusId: string | null | undefined): string {
        if (applicantStatusId == "0" || applicantStatusId == null || applicantStatusId == "" || applicantStatusId == undefined) return "Error";
        let value = this.getSortedByOrdinal.find((value) => applicantStatusId == value.id);
        return value ? value.color : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): ApplicantStatus[] {
        return this.applicantStatus.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getApplicantStatusOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
